var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"picker-hourly-delivery"},[_c('SpFinder',{ref:"finder",class:['shop-finder', { 'no-multiple': !_vm.multiple }],attrs:{"other-config":{
      height: 460
    },"data":_vm.list,"fixed-row-action":true,"setting":{
      columns: [
        { name: 'ID', key: 'id', width: 120 },
        { name: '名稱', key: 'title' }
      ]
    }},on:{"select":_vm.onSelect,"selection-change":_vm.onSelectionChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }